import { Button as ButtonAntd, Col as ColAntd } from 'antd';
import styled from 'styled-components';

export const SeparatorRight = styled(ColAntd)`
  border-right: 1px solid #f0f0f0;
  margin-right: 10px;
`;

export const RemoveItemButton = styled(ButtonAntd)`
  color: #cccccc;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  line-height: 19px;
  &:hover {
    color: #cccccc;
  }
`;
